'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _WAMConstants = require('./constants/WAMConstants');

var _WAMPayloadUtil = require('./util/WAMPayloadUtil');

var _GlobalData = require('./util/GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _AnalyticsUtil = require('./util/AnalyticsUtil');

var _AnalyticsUtil2 = _interopRequireDefault(_AnalyticsUtil);

var _ThorDetectUtil = require('./util/ThorDetectUtil');

var _ThorDetectUtil2 = _interopRequireDefault(_ThorDetectUtil);

var _WAMMessageManager = require('./WAMMessageManager');

var _WAMMessageManager2 = _interopRequireDefault(_WAMMessageManager);

var _WAMUtil = require('./WAMUtil');

var _WAMUtil2 = _interopRequireDefault(_WAMUtil);

var _WAMErrors = require('./errors/WAMErrors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WAMConnectionManager = function () {
	function WAMConnectionManager() {
		var _this = this;

		_classCallCheck(this, WAMConnectionManager);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
		this.wamConnectionAnalyticsParams = {};
		this.doesThorSupportInline = null;
		this.sourceType = null;

		// CCHome Specific
		// If internet connection goes away socket is disconnected and all states will be reset.
		window && window.addEventListener(_WAMConstants.wamEvents.connection.offline, function () {
			return _this.destroySocket();
		});
		// When internet connection comes back, connection with Thor is reinitiated.
		window && window.addEventListener(_WAMConstants.wamEvents.connection.online, function () {
			_this.doesThorSupportInline && _this.reconnectToThor(_WAMConstants.wamEvents.analytics.online);
		});
		// To handle apps tab has come is focus
		var hidden = 'hidden';
		if (hidden in document) {
			this.addDocumentFocusListner('visibilitychange');
		} else if ((hidden = 'mozHidden') in document) {
			this.addDocumentFocusListner('mozvisibilitychange');
		} else if ((hidden = 'webkitHidden') in document) {
			this.addDocumentFocusListner('webkitvisibilitychange');
		} else if ((hidden = 'msHidden') in document) {
			this.addDocumentFocusListner('msvisibilitychange');
		}
		this.addTabFocusListner('focus');
	}

	// Attach event to initiate Thor connection when apps tab has come in focus


	// Singleton


	_createClass(WAMConnectionManager, [{
		key: 'addTabFocusListner',
		value: function addTabFocusListner(eventName) {
			var _this2 = this;

			window && window.addEventListener(eventName, function () {
				_this2.doesThorSupportInline && _this2.reconnectToThor(_WAMConstants.wamEvents.analytics.appsFocus);
			});
		}
	}, {
		key: 'addDocumentFocusListner',
		value: function addDocumentFocusListner(eventName) {
			var _this3 = this;

			document.addEventListener(eventName, function () {
				_this3.doesThorSupportInline && _this3.reconnectToThor(_WAMConstants.wamEvents.analytics.appsFocus);
			});
		}

		/**
   * on Thor disconnection this method is used to reconnect with Thor
   */

	}, {
		key: 'reconnectToThor',
		value: function reconnectToThor(sourceType, wamConfig) {
			var _this4 = this;

			if (_WAMUtil2.default.didExitFromWAMWorkFlow) {
				_WAMUtil2.default.printLog('Ignoring reconnect to Thor attempt as CCH is not on inline.');
				return;
			}
			if (this.sourceType) {
				_WAMUtil2.default.printLog('Ignoring reconnect to Thor attempt for: ' + sourceType + ', as it is being exeucted by: ' + this.sourceType + ' or already connected.');
				return;
			}
			if (!_WAMUtil2.default.isTokenValid()) {
				this.destroySocket();
				return;
			}
			if (_WAMUtil2.default.areClientsConnected()) {
				this.sourceType = null;
				_WAMUtil2.default.printLog(sourceType + ' event is ignored as clients are already connected');
				return;
			}
			var reconnectToThorPromise = new Promise(function (resolve, reject) {
				_this4.sourceType = sourceType;
				_WAMUtil2.default.printLog('Pinging Thor as Thor disconnected, source type: ' + sourceType);
				_WAMUtil2.default.initThorConnection(wamConfig || { timeout: _WAMConstants.wamTimeouts.thorConnectionTimoutOnAutoRetrial });
				var retryCount = 1;
				var reconnectToThor = setInterval(function () {
					if (_WAMUtil2.default.areClientsConnected()) {
						clearInterval(reconnectToThor);
						_WAMUtil2.default.printLog('Connection with Thor established, source type: ' + sourceType);
						resolve(true);
						return;
					}
					if (retryCount === _WAMConstants.cchomeThorConnection.reconnectOnThorDisconnect.noOfRetries) {
						clearInterval(reconnectToThor);
						_WAMUtil2.default.printLog('Connection with Thor couldn\'t be established, source type: ' + sourceType);
						reject(false);
						return;
					}
					_WAMUtil2.default.printLog('Pinging Thor as Thor disconnected, source type: ' + sourceType);
					_WAMUtil2.default.initThorConnection(wamConfig || { timeout: _WAMConstants.wamTimeouts.thorConnectionTimoutOnAutoRetrial });
					retryCount++;
				}, _WAMConstants.cchomeThorConnection.reconnectOnThorDisconnect.retryInterval);
			});

			reconnectToThorPromise.then(function () {
				_this4.sourceType = null;
			}).catch(function () {
				_this4.sourceType = null;
			});
		}

		/**
   * Initialize the socket object and registers the event handler
   * @returns {Promise}
   */

	}, {
		key: 'init',
		value: function init(isLongWaitingEnabled) {
			var _this5 = this;

			if (this.socket && this.socket.connected) {
				return new Promise(function (resolve) {
					_WAMUtil2.default.printLog('Socket is already connected');
					_this5.socket.connected ? resolve(true) : resolve(false);
				});
			}
			var onConnectCallback = function onConnectCallback(resolve) {
				_this5.reset();
				_this5.removeEvents();
				_this5.setCallbackForClientState();
				_WAMMessageManager2.default.setCallbackForClientMsg();
				_this5.setDisconnectionCallback();
				_this5.setErrorCallback();
				_this5.setConnectErrorCallback();
				_this5.socket.connected ? resolve(true) : resolve(false);
			};
			return new Promise(function (resolve) {
				var ccwConnectTimer = new Date().getTime();
				_this5.initializeSocket();
				if (!_this5.socket) {
					resolve(false);
					return;
				}
				var timeout = isLongWaitingEnabled ? _WAMConstants.wamTimeouts.thorConnectionTimeoutOnWamInBackground : 20000;
				setTimeout(function () {
					// To make sure the promise is complete in case socket didn't get connection in 20 seconds.
					if (!(_this5.socket && _this5.socket.connected)) {
						_WAMUtil2.default.printLog('Connection of client with WAM couldn\'t be established');
						!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.clientAndWAMConnectionTimeout);
						resolve(false);
					}
				}, timeout);
				_WAMUtil2.default.printLog('New socket has been initialized');

				_this5.socket.on(_WAMConstants.wamEvents.receiveEvents.connect, function () {
					_WAMUtil2.default.printLog('Socket on connect is called');
					var ccwAuthenticateTimer = new Date().getTime();
					var timeTakenInConnection = ccwAuthenticateTimer - ccwConnectTimer;
					_AnalyticsUtil2.default.trackTimeOnCompletion(timeTakenInConnection, _WAMConstants.analyticsEvents.trackTime.clientWamConnectTimeTaken);
					_this5.socket.emit(_WAMConstants.wamEvents.sendEvents.authenticate, {
						authorization: '' + _GlobalData2.default.accessToken,
						'x-adobe-app-id': _GlobalData2.default.clientId
					}, function (authResult) {
						_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - ccwAuthenticateTimer, _WAMConstants.analyticsEvents.trackTime.clientWamAuthenticationTimeTaken, authResult.authenticated);
						if (authResult.authenticated) {
							_this5.channelGuid = authResult.channelGuid;
							_WAMUtil2.default.printLog('CreativeCloudHome connection is authenticated');
							onConnectCallback(resolve);
						} else {
							!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.accessTokenInvalidOrExpired);
							resolve(false);
						}
					});
				});
			});
		}

		/**
   *  Initializes the socket
   */

	}, {
		key: 'initializeSocket',
		value: function initializeSocket() {
			this.destroySocket();
			this.socket = _socket2.default.connect(_WAMConstants.wamUrls[_GlobalData2.default.env], {
				path: '/v2/ws',
				reconnection: false,
				transports: ['websocket'],
				query: 'api_key=' + _GlobalData2.default.clientId
			});
			this.setErrorCallback();
			this.setConnectErrorCallback();
		}

		// To handle explict disconnect call from client side.

	}, {
		key: 'disconnect',
		value: function disconnect() {

			this.socket && this.socket.connected && this.socket.disconnect();
			this.reset();
			this.removeEvents();
		}

		/**
   * To reset the local variable like currentDevice and thor products
   */

	}, {
		key: 'reset',
		value: function reset() {
			this.currentDevice = null;
			this.isCCHomeRegistered = null;
			this.wamConnectionAnalyticsParams = {};
			this.doesThorSupportInline = null;
			_WAMMessageManager2.default.resetThorAppsState();
		}

		/**
   * To destroy socket and all its registered events.
   */

	}, {
		key: 'destroySocket',
		value: function destroySocket() {
			if (!this.socket) {
				return;
			}
			this.reset();
			this.removeEvents();
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.connect);
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.error);
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.connectError);
			this.connectionErrorCount = 0;
			this.socket.disconnect();
			this.socket = null;
		}

		/**
   * To remove the listeners already added for the events.
   */

	}, {
		key: 'removeEvents',
		value: function removeEvents() {
			if (!this.socket) {
				return;
			}
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.clientMsg);
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.sendCurrentDevice);
			this.socket.off(_WAMConstants.wamEvents.receiveEvents.clientStates);
		}

		/* To verify if CCHome is registered with WAM */

	}, {
		key: 'isCCHReadyToRecvData',
		value: function isCCHReadyToRecvData() {
			return this.socket && this.socket.connected && this.currentDevice && this.isCCHomeRegistered;
		}

		/*
   *	To cater connection error scenario
   */

	}, {
		key: 'setErrorCallback',
		value: function setErrorCallback() {
			var _this6 = this;

			if (!this.socket) {
				return;
			}
			if (this.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.error)) {
				return;
			}
			this.socket.on(_WAMConstants.wamEvents.receiveEvents.error, function (error) {
				_WAMUtil2.default.printLog('Error received from socket');
				_this6.sendAnalyticsInErrState('error', error);
				_this6.connectionErrorCount = _this6.connectionErrorCount || 0;
				if (_this6.connectionErrorCount >= _WAMConstants.cchomeWamConnection.onErrorReconnectAttempts) {
					_this6.destroySocket();
				}
				_this6.connectionErrorCount++;
			});
		}

		// Common method to send analytics in case of error and connect_error form socket.

	}, {
		key: 'sendAnalyticsInErrState',
		value: function sendAnalyticsInErrState(errorCategory, error) {
			var errorDesc = error;
			if (error && typeof error !== 'string') {
				errorDesc = JSON.stringify(error);
			}
			if (!errorDesc) {
				errorDesc = 'unknown';
			}
			errorDesc = _WAMUtil2.default.appendSourceInDesc(errorDesc);
			_WAMUtil2.default.printLog('socket error desc ' + errorDesc);
			if (!_WAMUtil2.default.errorAnalyticsSent) {
				_AnalyticsUtil2.default.sendAnalytics({
					eventName: _WAMConstants.analyticsEvents.onClientWAMConnection,
					status: false,
					errorType: errorCategory,
					errorDesc: errorDesc
				});
				_WAMUtil2.default.errorAnalyticsSent = true;
			}
		}

		/*
   *	To cater connection error scenario, triggered when timeout occurs in socket connection
   */

	}, {
		key: 'setConnectErrorCallback',
		value: function setConnectErrorCallback() {
			var _this7 = this;

			if (!this.socket) {
				return;
			}
			if (this.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.connectError)) {
				return;
			}
			this.socket.on(_WAMConstants.wamEvents.receiveEvents.connectError, function (error) {
				_WAMUtil2.default.printLog('Connect_error received from socket');
				_this7.sendAnalyticsInErrState('timeout', error);
			});
		}

		/*
   *	To cater CCHome disconnects scenario, CCHome will discard previously received deviceId and ping Thor again.
   */

	}, {
		key: 'setDisconnectionCallback',
		value: function setDisconnectionCallback() {
			var _this8 = this;

			if (!this.socket) {
				return;
			}
			if (this.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.disconnect)) {
				return;
			}
			this.socket.on(_WAMConstants.wamEvents.receiveEvents.disconnect, function (disconnectReason) {
				_WAMUtil2.default.printLog('socket disconnected due to: ' + disconnectReason);
				_this8.reset();
				_this8.removeEvents();
				/* switch (disconnectReason) {
    case socketDisconnectReasons.transportClose:
    case socketDisconnectReasons.pingTimeout:{
    setTimeout(() => {
    wamUtil.printLog('Reinitiating Thor connection');
    wamUtil.resetInitThorConnectionFlag();
    wamUtil.initThorConnection({timeout: wamTimeouts.thorConnectionTimoutOnAutoRetrial});
    }, 5000);
    }
    } */
			});
		}
	}, {
		key: 'verifyCCDStateAndRegisterCallback',
		value: function verifyCCDStateAndRegisterCallback(_ref) {
			var _this9 = this;

			var wamConfig = _ref.wamConfig,
			    isLongWaitingEnabled = _ref.isLongWaitingEnabled,
			    resolve = _ref.resolve,
			    reject = _ref.reject;

			// To verify Thor apps state has been received and clients are connected
			if (_WAMUtil2.default.areClientsConnected()) {
				_WAMUtil2.default.printLog('Sending analytics true for Thor apps state. Got success in first attempt');
				_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
					eventName: _WAMConstants.analyticsEvents.onClientRecvThorAppsState,
					status: true
				});
				this.wamConnectionAnalyticsParams.recvThorAppsState = 'success';
				resolve(true);
				return;
			}

			//Setting up a timeout if connection doesn't happen and reject the call
			var timeoutValue = isLongWaitingEnabled ? _WAMConstants.wamTimeouts.thorConnectionTimeoutOnWamInBackground : 20000;
			var timeout = setTimeout(function () {
				// To make sure the promise is complete in case current device never received and to avoid memory leaks in such scenario.
				if (!_WAMUtil2.default.areClientsConnected()) {
					!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.thorConnectionTimeout);
					reject(false);
				}
			}, timeoutValue);

			_WAMMessageManager2.default.onProductsStateReceived = function () {
				if (_WAMUtil2.default.areClientsConnected()) {
					_WAMUtil2.default.printLog('Sending analytics true for Thor apps state');
					_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
						eventName: _WAMConstants.analyticsEvents.onClientRecvThorAppsState,
						status: true
					});
					_this9.wamConnectionAnalyticsParams.recvThorAppsState = 'success';
					_WAMUtil2.default.printLog('Received Thor app state response');
					resolve(true);
				}
				_WAMMessageManager2.default.onProductsStateReceived = null;
				clearTimeout(timeout);
			};
		}

		/* To fetch current device Id and apps state from thor and perform CCHome registration if not registered already */

	}, {
		key: 'fetchAppsStateAndRegisterCCH',
		value: function fetchAppsStateAndRegisterCCH(isLongWaitingEnabled, wamConfig) {
			var _this10 = this;

			return new Promise(function (resolve, reject) {
				if (!_this10.socket) {
					reject(false);
					return;
				}
				_this10.verifyCCDStateAndRegisterCallback({ wamConfig: wamConfig, isLongWaitingEnabled: isLongWaitingEnabled, resolve: resolve, reject: reject });

				_WAMUtil2.default.printLog('channelGuid: ' + _this10.channelGuid);
				var currentDeviceTimer = new Date().getTime();
				_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.getCurrentDevice, function (data) {
					// Making getCurrent device request to WAM
					_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - currentDeviceTimer, _WAMConstants.analyticsEvents.trackTime.v1.getCurrentDeviceTimeTaken);
					_WAMUtil2.default.printLog('getCurrentDevice response: ' + data);
					if (!_this10.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.sendCurrentDevice)) {
						_this10.socket.on(_WAMConstants.wamEvents.receiveEvents.sendCurrentDevice, function (currentDeviceResp) {
							// Callback when current device is received
							_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - currentDeviceTimer, _WAMConstants.analyticsEvents.trackTime.v1.receiveCurrentDeviceTimeTaken);
							if (!currentDeviceResp) {
								_this10.wamConnectionAnalyticsParams.recvDeviceId = 'failure';
								_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
									eventName: _WAMConstants.analyticsEvents.onReceiveCurrentDevice,
									status: false,
									errorType: 'error',
									errorDesc: _WAMUtil2.default.appendSourceInDesc('Thor failed to respond')
								});
								reject(false);
								return;
							}
							_this10.wamConnectionAnalyticsParams.recvDeviceId = 'success';
							_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
								eventName: _WAMConstants.analyticsEvents.onReceiveCurrentDevice,
								status: true
							});
							_WAMUtil2.default.printLog('sendCurrentDevice response: ' + (currentDeviceResp ? 'successful' : 'unsuccessful'));

							_this10.currentDevice = currentDeviceResp.currentDevice;
							var registrationTimer = new Date().getTime();
							var payloadForThorAppsState = (0, _WAMPayloadUtil.getPayloadForThorAppsState)(_GlobalData2.default.userContext.userId, _this10.currentDevice.deviceId);
							var payloadForAppsPanelStatus = (0, _WAMPayloadUtil.getPayloadForAppsPanelStatus)(_GlobalData2.default.userContext.userId, _this10.currentDevice.deviceId);
							if (_this10.isCCHReadyToRecvData()) {
								_WAMUtil2.default.printLog('CCHome is already registered, hence sending request for AppsPanel status');
								_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForAppsPanelStatus);
								_WAMUtil2.default.printLog('CCHome is already registered, hence sending request for Thor apps state');
								_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForThorAppsState);
							} else {
								// To perform CCH registration
								var payLoadForRegistration = (0, _WAMPayloadUtil.getPayloadForRegistration)(_GlobalData2.default.userContext.userId, _GlobalData2.default.userContext.displayName, _GlobalData2.default.userContext.email, _this10.currentDevice.deviceId);
								_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.registerClient, payLoadForRegistration, function (registerResp) {
									_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - registrationTimer, _WAMConstants.analyticsEvents.trackTime.clientWamRegistrationTimeTaken, registerResp);
									_WAMUtil2.default.printLog('Register reponse: ' + registerResp);
									if (registerResp) {
										_this10.isCCHomeRegistered = true;
										_WAMUtil2.default.printLog('Sending analytics for CCH registration with WAM: ' + registerResp);
										_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
											eventName: _WAMConstants.analyticsEvents.onClientRegistratonWithWAM,
											status: true
										});
										_this10.wamConnectionAnalyticsParams.ccHRegistered = 'success';
										_WAMUtil2.default.printLog('CCHome is registered, hence sending request for AppsPanel status');
										_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForAppsPanelStatus);
										_this10.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForThorAppsState);
										return;
									}
									!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.clientFailedToRegisterAtWAM);
									reject(false);
									return;
								});
							}
						});
					}

					// If getCurrent device call is acknowledged by WAM make request to Thor for sending current device Id.
					if (data) {
						_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
							eventName: _WAMConstants.analyticsEvents.onGetCurrentDevice,
							status: true
						});
						var wamArgs = { pingType: 'thor', version: _WAMConstants.wamConnectWF.v1 };
						var ccdTriggerTimer = new Date().getTime();
						_ThorDetectUtil2.default.checkForThor(wamArgs).then(function (isThorPresent) {
							_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - ccdTriggerTimer, _WAMConstants.analyticsEvents.trackTime.ccdTriggerTimeTaken, isThorPresent);
							_this10.doesThorSupportInline = isThorPresent;
							if (!isThorPresent) {
								_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
									eventName: _WAMConstants.analyticsEvents.onThorDetectionByClient,
									status: false
								});
								!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.thorForWAMConnectionNotPresent);
								reject(false);
								return;
							}
							_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
								eventName: _WAMConstants.analyticsEvents.onThorDetectionByClient,
								status: true
							});
							_WAMUtil2.default.printLog('Thor ping response: ' + isThorPresent);
						});
					} else {
						_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
							eventName: _WAMConstants.analyticsEvents.onGetCurrentDevice,
							status: false
						});
					}
				});
			});
		}

		/* In V2- workflow, which is based on http ping to fetch current device Id and apps state from thor and perform CCHome registration if not registered already */

	}, {
		key: 'httpPingFetchAppsStateAndRegisterCCH',
		value: function httpPingFetchAppsStateAndRegisterCCH(isLongWaitingEnabled, wamConfig) {
			var _this11 = this;

			return new Promise(function (resolve, reject) {
				if (!_this11.socket) {
					reject(false);
					return;
				}

				_this11.verifyCCDStateAndRegisterCallback({ wamConfig: wamConfig, isLongWaitingEnabled: isLongWaitingEnabled, resolve: resolve, reject: reject });

				_WAMUtil2.default.printLog('channelGuid: ' + _this11.channelGuid);
				_this11.currentDevice = { deviceId: _this11.channelGuid };
				var registrationTimer = new Date().getTime();
				var payloadForThorAppsState = (0, _WAMPayloadUtil.getPayloadForThorAppsState)(_GlobalData2.default.userContext.userId, _this11.currentDevice.deviceId);
				var payloadForAppsPanelStatus = (0, _WAMPayloadUtil.getPayloadForAppsPanelStatus)(_GlobalData2.default.userContext.userId, _this11.currentDevice.deviceId);
				if (_this11.isCCHReadyToRecvData()) {
					_WAMUtil2.default.printLog('CCHome is already registered, hence sending request for AppsPanel status');
					_this11.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForAppsPanelStatus);
					_WAMUtil2.default.printLog('CCHome is already registered, hence sending request for Thor apps state');
					_this11.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForThorAppsState);
				} else {
					// To perform CCH registration
					var payLoadForRegistration = (0, _WAMPayloadUtil.getPayloadForRegistration)(_GlobalData2.default.userContext.userId, _GlobalData2.default.userContext.displayName, _GlobalData2.default.userContext.email, _this11.currentDevice.deviceId);
					_this11.socket.emit(_WAMConstants.wamEvents.sendEvents.registerClient, payLoadForRegistration, function (registerResp) {
						_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - registrationTimer, _WAMConstants.analyticsEvents.trackTime.clientWamRegistrationTimeTaken, registerResp);
						_WAMUtil2.default.printLog('Register reponse: ' + registerResp);
						if (registerResp) {
							_this11.isCCHomeRegistered = true;
							_WAMUtil2.default.printLog('Sending analytics for CCH registration with WAM: ' + registerResp);
							_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
								eventName: _WAMConstants.analyticsEvents.onClientRegistratonWithWAM,
								status: true
							});
							_this11.wamConnectionAnalyticsParams.ccHRegistered = 'success';
							_WAMUtil2.default.printLog('CCHome is registered, hence sending request for AppsPanel status');
							var ccdTriggerTimer = new Date().getTime();
							// http Ping to Thor and pass on channelGuid
							var wamArgs = {
								pingType: _WAMConstants.pingType.httpPingInitiateWorkflow,
								version: _WAMConstants.wamConnectWF.v2,
								channelGuid: _this11.channelGuid
							};
							_ThorDetectUtil2.default.checkForThor(wamArgs).then(function (isThorRegistrationSuccessful) {
								_AnalyticsUtil2.default.trackTimeOnCompletion(new Date().getTime() - ccdTriggerTimer, _WAMConstants.analyticsEvents.trackTime.ccdTriggerTimeTaken, isThorRegistrationSuccessful);
								if (isThorRegistrationSuccessful) {
									_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
										eventName: _WAMConstants.analyticsEvents.onThorDetectionByClient,
										status: true
									});
									_this11.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForAppsPanelStatus);
									_this11.socket.emit(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForThorAppsState);
								} else {
									_WAMUtil2.default.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({
										eventName: _WAMConstants.analyticsEvents.onThorDetectionByClient,
										status: false
									});
								}
							});

							return;
						}
						!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.clientFailedToRegisterAtWAM);
						reject(false);
						return;
					});
				}
			});
		}

		/*
   *	To cater Thor disconnects scenario, If Thor disconnects,  WAM will send clientStates to CCHome
   *	CCHome will discard previously received deviceId and ping Thor again. Here number of retrials needs to be defined.
   *  Should CCHOme disconnects its connection with WAM.
   *  // {"clientStates":[{"deviceId":"0368c8e2-796a-449a-8236-4eb9b2beaeb2","clientType":"engine","connected":false}]}
   */

	}, {
		key: 'setCallbackForClientState',
		value: function setCallbackForClientState() {
			var _this12 = this;

			if (!this.socket) {
				return;
			}
			if (this.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.clientStates)) {
				return;
			}

			this.socket.on(_WAMConstants.wamEvents.receiveEvents.clientStates, function (clientStateResp) {
				_WAMUtil2.default.printLog(clientStateResp);
				if (clientStateResp && clientStateResp.clientStates) {
					clientStateResp.clientStates.forEach(function (clientState) {
						_WAMUtil2.default.printLog(clientState);
						if (_this12.currentDevice !== null && clientState.deviceId === _this12.currentDevice.deviceId && clientState.clientType === _WAMConstants.clientTypes.engine) {

							if (clientState.userMismatch && _GlobalData2.default.disconnectOnUserMismatch) {
								_WAMUtil2.default.printLog('Disconnecting as user is mismatched');
								var errorDesc = 'Usermismatch on client side';
								_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.onClientRecvThorAppsState, status: false, errorType: 'usermismatch', errorDesc: errorDesc });
								!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.userMismatch);
								_this12.wamConnectionAnalyticsParams.recvThorAppsState = 'usermismatch';
								_this12.disconnect();
								return;
							}
							if (clientState.connected === false) {
								_this12.disconnect();
								_this12.reconnectToThor(_WAMConstants.wamEvents.analytics.thorDisconnect);
							}
						}
					});
				}
			});
		}
	}]);

	return WAMConnectionManager;
}();

exports.default = new WAMConnectionManager();